import React from 'react'
import PropTypes from 'prop-types'

import AceEditor from 'react-ace'

import 'brace/mode/javascript'
import 'brace/theme/github'

import { withStyles } from '@material-ui/core/styles'
import {
  Button,
  FormLabel,
  Input,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

import TriggerListView from './TriggerListView'
import ParamListView from './ParamListView'

class AutomationEditDialog extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    automation: PropTypes.object,
    unitId: PropTypes.number,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps ={
    automation: {
      name: '',
      script: '',
      triggers: [],
      params: {},
    },
    unitId: undefined,
  }

  static styles = (theme) => ({
    formSection: {
      margin: theme.spacing(1),
      display: 'block',
    },
    formLabel: {
      display: 'block',
    },
  })

  state = { automation: this.props.automation }

  componentWillReceiveProps(nextProps) {
    const { automation } = nextProps
    this.setState({ automation })
  }

  onNameChange = (e) => {
    const name = e.currentTarget.value

    this.setState(
      (prevState) => ({
        automation: {
          ...prevState.automation,
          name,
        },
      }),
    )
  }

  onScriptChange = (val) => {
    this.setState(
      (prevState) => ({
        automation: {
          ...prevState.automation,
          script: val,
        },
      }),
    )
  }

  onSave = () => {
    this.props.onSave(this.state.automation)
  }

  onClose = () => {
    this.props.onClose()
  }

  onAddTrigger = (trigger) => {
    this.setState(
      (prevState) => ({
        automation: {
          ...prevState.automation,
          triggers: [...prevState.automation.triggers, trigger],
        },
      }),
    )
  }

  onRemoveTrigger = (trigger) => {
    this.setState(
      (prevState) => ({
        automation: {
          ...prevState.automation,
          triggers: prevState.automation.triggers.filter((t) => t !== trigger),
        },
      }),
    )
  }

  onChangeParams = (params) => {
    this.setState(
      (prevState) => ({
        automation: {
          ...prevState.automation,
          params,
        },
      }),
    )
  }

  render() {
    const { unitId, classes } = this.props
    const { automation } = this.state
    return (
      <Dialog open fullScreen onClose={this.onClose}>
        <DialogTitle>
          {automation.id ? `Edit Automation ${automation.id}` : 'Add Automation'}
        </DialogTitle>
        <DialogContent>
          <div className={classes.formSection}>
            <FormLabel className={classes.formLabel}>Name</FormLabel>
            <Input
              autoFocus
              value={automation.name}
              onChange={this.onNameChange}
            />
          </div>

          <div className={classes.formSection}>
            <FormLabel className={classes.formLabel}>Triggers</FormLabel>
            <TriggerListView
              triggers={automation.triggers || []}
              unitId={unitId}
              onAdd={this.onAddTrigger}
              onRemove={this.onRemoveTrigger}
            />
          </div>

          <div className={classes.formSection}>
            <FormLabel className={classes.formLabel}>Parameters</FormLabel>
            <ParamListView
              params={automation.params || {}}
              unitId={unitId}
              onChange={this.onChangeParams}
            />
          </div>

          <div className={classes.formSection}>
            <FormLabel className={classes.formLabel}>Script</FormLabel>
            <AceEditor
              mode="javascript"
              theme="github"
              onChange={this.onScriptChange}
              value={automation.script}
              name={`automation-${automation.id}`}
              width="100%"
              editorProps={{ $blockScrolling: Infinity }}
            />
          </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={this.onClose}>
            Cancel
          </Button>
          <Button onClick={this.onSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(AutomationEditDialog.styles)(AutomationEditDialog)
